
import PageHeader from '@/components/core/PageHeader';
import tableLoading from '@/components/tableLoading';
import NoContent from '@/components/customer-content/NoContent';
import ExploreCard from '@/components/ExploreCard';
import ImageHeader from '@/components/core/ImageHeader';
export default {
  scrollToTop: true,
  components: {
    PageHeader,
    tableLoading,
    NoContent,
    ExploreCard,
    ImageHeader,
  },
  data() {
    return {
      listingLoading: true,
      citySlug: null,
      cityDetails: null,
      placesDetails: null,
    }
  },
  async validate({
    params,
    store
  }) {
    // await operations
    if (params.city != (null || "")) {
      this.citySlug = params.city;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.citySlug = this.$route.params.city;
  },
  mounted() {
    this.getCityDetails();
    this.getPlacesInCity();
  },
  methods: {
    async getCityDetails() {
      this.cityDetails = await fetch(this.$config.fetchUrl + '/api/cities/app/' + this.citySlug).then(res => res
        .text());
      this.cityDetails = this.getCryptKey(this.cityDetails);
    },
    async getPlacesInCity() {
      this.placesDetails = await fetch(this.$config.fetchUrl + '/api/posts/app/getPlacesInCity/' + this.citySlug).then(res => res
        .text());
      this.placesDetails = this.getCryptKey(this.placesDetails);
      this.placesDetails.sort((x, y) => Number(y.featured) - Number(x.featured));
      this.listingLoading = false;
    },
    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },
  }
}
